import React from "react";
import { Card, CustomInput, Badge } from "reactstrap";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';

const PromoThumbListView = ({ promo, isSelect, onCheckItem }) => {
    let details = '';
    let type = '';
    if (promo.type === 'PercentageDiscount') {
        type = 'Flat % Discount'
        details = promo.discount + "% Discount"
    }
    else if (promo.type === 'StayPay') {
        type = 'Free Nights When Staying Longer'
        details = "Stay " + promo.stayDays + " days, Pay " + promo.payDays + " days"
    }
    else if (promo.type === 'StaySave') {
        type = '% Discount When Staying Longer'
        details = promo.discount + "% Discount for Minmum Stay of " + promo.saveDays
    }

    return (
        <Colxx xxs="12" key={promo.id} className="mb-3">
            <Card
                onClick={event => onCheckItem(event, promo.id)}
                className={classnames("d-flex flex-row", {
                    active: isSelect
                })}
            >
                <div className="custom-control custom-checkbox pl-1 align-self-center">
                    <CustomInput
                        className="item-check mb-0"
                        type="checkbox"
                        id={`check_${promo.id}`}
                        checked={isSelect}
                        onChange={() => { }}
                        label=""
                    />
                </div>
                <img
                    alt={promo.name}
                    src={
                        promo.images[0]
                            ? promo.images[0].url
                            : 'https://via.placeholder.com/250x150'
                    }
                    className="list-thumbnail responsive border-0"
                />

                <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                    <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                        <p className="w-25 w-sm-100 list-item-heading mb-1 mr-1">
                            {promo.name}
                        </p>
                        <p className="mb-1 text-muted text-small w-15 w-sm-100 mr-1">
                            {type}
                        </p>
                        <p className="mb-1 text-muted text-small w-15 w-sm-100 mr-1">
                            {details}
                        </p>
                        <p className="mb-1 text-muted text-small w-15 w-sm-100 mr-1">
                            {promo.displayText}
                        </p>
                        <p className="mb-1 text-muted text-small w-15 w-sm-100 mr-1">
                            {promo.displayFreeText}
                        </p>
                        <p className="mb-1 text-muted text-small w-15 w-sm-100 mr-1">
                            {promo.conditions}
                        </p>
                    </div>

                </div>
            </Card>
        </Colxx>
    )
}
export default PromoThumbListView;